<template>
  <div class="mt-3" v-if="completeLoadingOpp">
    <div class="text-center mt-1 pr-2">
      <span>{{ $t("lang.label.planned") }}</span>
    </div>
    <div class="wTimeLine mt-4">
      <ul>
        <div class="card ml-4 p-2" v-if="isCommingTimelineEmpty">
          <span>{{ $t("lang.label.nothingplannedatthemoment") }}</span>
        </div>

        <li
          class="activityLine border-left"
          v-for="(item, index) in timelineComming"
          :key="`${index}-comming`"
        >
          <span
            class="iconline"
            :class="timelineIconClasses(item, currentUser.role_id)"
          ></span>
          <div
            v-if="item.event_id == 3 && !isType(item, 'activity')"
            class="ml-3 timeline-meeting-slot"
          >
            <CalendlyEvent
              :fromTimeLineInfo="true"
              :id="item.comment"
              :meeting_id="item.id"
              @open-modal-mod-meet="$emit('open-modal-mod-meet', $event)"
            />
          </div>
          <div class="card ml-3 p-2" v-else-if="!isType(item, 'activity')">
            <div class="d-flex">
              <small
                class="font-weight-bold"
                v-if="item.type != 'emailscheduled' && item.event_id != 3"
                >{{ item.name }} {{ $t("lang.label.createdanevent") }} ({{
                  calcSpanDate(item.event_date)
                }}) :
              </small>

              <div
                class="cursor-pointer"
                v-if="item.type == 'emailscheduled'"
                @click="openItem(item.id)"
              >
                <small v-if="!isOpenItem(item)" class="mr-2 text-primary"
                  ><i class="icon-plus"></i> {{ $t("lang.label.open") }}</small
                >
                <small v-if="isOpenItem(item)" class="mr-2 text-danger"
                  ><i class="icon-plus"></i>
                  {{ $t("lang.button.close") }}</small
                >
                <small class="font-weight-bold">
                  {{
                    $t(
                      "lang.label.oliversupcomingactiontheengagedprospectsofthiscompanywillberelaunchedon"
                    )
                  }}
                  {{ calcSpanDate(item.event_date) }} :
                </small>
              </div>
              <div class="font-weight-bold" v-if="isType(item, 'comment')">
                {{ $t("lang.label.leftanote") }} :
              </div>
            </div>

            <div
              class="d-flex justify-content-between mt-2"
              v-if="item.event_id != 3"
            >
              <pre
                class="text-muted"
                v-html="getEmail(item.comment, item.id)"
                v-if="isType(item, 'event')"
              ></pre>
              <pre
                class="text-muted"
                v-html="getEmail(item.comment, item.id)"
                v-else-if="isOpenItem(item) && isType(item, 'emailscheduled')"
              ></pre>
              <pre
                class="text-muted"
                v-html="getEmail(item.comment, item.id)"
                v-else-if="!isType(item, 'emailscheduled')"
              ></pre>
            </div>
            <div class="">
              <small
                class="float-right cdarkgray"
                v-if="item.creation_date && item.event_id != 3"
              >
                {{ calcSpanDate(item.creation_date) }}</small
              >
            </div>
          </div>
        </li>

        <li
          class="activityLine"
          :class="!isCommingTimelineEmpty ? '' : ''"
          v-if="!isPassedTimelineEmpty"
        >
          <div class="text-center mt-4 pr-2">
            <span>{{ $t("lang.label.done") }}</span>
          </div>
        </li>

        <li
          class="cursor-pointer activityLine border-left pb-4"
          v-for="(item, index) in timelineRecent"
          :key="`${index}-passed`"
        >
          <span class="iconline icon-one-finger-tap"></span>
          <div class="card ml-3 p-2">
            <div>
              <img
                width="20px"
                height="20px"
                :src="getBusinessPhoto(item.photo)"
                class="rounded-circle mr-2 border-2 border border-success"
              />
              <small
                ><strong> {{ item.name }} </strong> ({{ item.email }})</small
              >
              <span class="badge badge-success ml-2 text-white">{{
                $t("lang.timeline.recentonline")
              }}</span>

              <small class="float-right"
                ><span
                  class="icon-clock"
                  :title="$t('lang.label.sessionduration')"
                ></span
                >{{ calcSpanDate(item.creation_date) }}</small
              >
            </div>
          </div>
        </li>

        <li
          v-if="status.name == 'Do not contact'"
          class="activityLine border-left pb-4"
        >
          <span class="iconline icon-warning"></span>
          <div class="ml-3">
            <div class="alert alert-danger" role="alert">
              Bonjour, un des membres de l’organisation a indiqué qu’il ne
              souhaitait plus être contacté dans le cadre de cette campagne. Les
              emails prévus pour ce contact ont été annulés
            </div>
          </div>
        </li>

        <template v-for="(item, index) in timelinePassed">
        <li
          v-if="shouldShowPassedTimelineItem(item)"
          class="cursor-pointer activityLine border-left pb-4"
          :key="`${index}-passed2`"
        >
          <span
            class="iconline"
            :class="timelineIconClasses(item, currentUser.role_id)"
            @click="openItem(item.id)"
          ></span>
          <div v-if="item.link == 'createdopportunity'">
            <div class="card ml-3 p-2">
              <strong>{{ $t("lang.label.opportunitywascreated") }}</strong>
              <p>
                <strong>{{ item.name | formatContactName(item.email) }}</strong>
                {{ $t("lang.label.hasopenedthedemolink") }}
              </p>
              <p>
                {{
                  $t(
                    "lang.label.theopportunitywascreatedandaddedtoyourcompanysaccount"
                  )
                }}
              </p>
              <small class="float-right cdarkgray">
                {{ calcSpanDate(item.creation_date) }}</small
              >
            </div>
          </div>

          <div v-else>
            <!-- Task Display in Timeline -->
            <div
              v-if="isRebootTaskCardItem(item)"
              class="card ml-3 p-3 task-card task-card--reboot"
            >
              <OpportunityOutputCard
                :item="item"
                :theme="getTaskCardTheme(item.event_id)"
              />
            </div>

            <TimelineCalendarActivityCard
              v-else-if="isType(item, 'activity')"
              :item="item"
              @toggle="openItem(item.id)"
            />

            <div
              v-if="
                item.event_id == 3 &&
                !isType(item, 'activity') &&
                !isType(item, 'task') &&
                (currentUser.role_id != 4 || item.event_id != 2)
              "
              class="ml-3 timeline-meeting-slot"
            >
              <CalendlyEvent
                :fromTimeLineInfo="true"
                :id="item.comment"
                :meeting_id="item.id"
                @open-modal-mod-meet="$emit('open-modal-mod-meet', $event)"
              />
            </div>
            <TimelineEmailCard
              v-else-if="
                isTimelineEmailItem(item) &&
                (currentUser.role_id != 4 || item.event_id != 2)
              "
              :item="item"
              :expanded="isOpenItem(item)"
              :is-other-user-card="item.user_id != currentUser.id"
              :role-id="currentUser.role_id"
              :activate-spark="activateSpark"
              :user-id="user_id"
              :selected-email="emails[item.id]"
              :is-modal-visible="isModalVisible"
              :can-show-reply-footer="permissionFront(item)"
              :is-reply-blocked="blocked()"
              :show-tags="showtags"
              :tags-for-item="tags[item.id]"
              :worddetected="worddetected"
              :campaign-tokens="campaignTokens"
              :highlighted-body-html="
                showtags &&
                Array.isArray(worddetected) &&
                worddetected.length
                  ? highlightedText(worddetected[0])
                  : ''
              "
              @toggle="openItem(item.id)"
              @retag="retag(item)"
              @unlink="unlikFromOportunity(item)"
              @reply="switchTextarea(item)"
              @close-reply="closeModal(item)"
            />

            <div
              class="card ml-3 p-2 cursor-pointer"
              v-else-if="
                !isType(item, 'activity') &&
                !isType(item, 'task') &&
                !isTimelineEmailItem(item) &&
                (currentUser.role_id != 4 || item.event_id != 2)
              "
              :class="item.user_id != currentUser.id ? 'bg-light' : ''"
            >
              <div class="d-block" v-if="item.event_id != 3">
                <small
                  class="font-weight-bold"
                  v-if="isType(item, 'event')"
                  @click="openItem(item.id)"
                >
                  {{ item.name }} {{ $t("lang.label.createdanevent") }} ({{
                    calcSpanDate(item.event_date)
                  }}) :</small
                >
                <small
                  class="font-weight-bold"
                  v-if="isType(item, 'comment')"
                  :class="item.user_id != currentUser.id ? 'text-primary' : ''"
                  >{{ $t("lang.label.notes") }}
                  <span v-if="currentUser.role_id != 4">({{ item.name }})</span>
                  :</small
                >
                <small
                  v-if="isType(item, 'comment')"
                  class="float-right cdarkgray"
                  >{{ calcSpanDate(item.creation_date) }}</small
                >
              </div>

              <div
                v-if="
                  isOpenItem(item) ||
                  isType(item, 'comment') ||
                  isType(item, 'event')
                "
              >
                <div
                  class="d-flex justify-content-between mt-2"
                  v-if="item.event_id != 3"
                >
                  <pre
                    class="text-muted"
                    v-html="getEmail(item.comment, item.id)"
                    v-if="isType(item, 'event')"
                  ></pre>

                  <span
                    v-if="
                      isType(item, 'autocomment') &&
                      item.comment == 'absentactive'
                    "
                  >
                    {{ $t("lang.task.absentactive") }}
                  </span>
                  <span
                    v-if="
                      isType(item, 'autocomment') &&
                      item.comment == 'cancelrefused'
                    "
                  >
                    {{ $t("lang.refuse.cancelrefused") }}
                  </span>
                  <span
                    v-if="
                      isType(item, 'autocomment') &&
                      item.comment == 'cancelabsent'
                    "
                  >
                    {{ $t("lang.refuse.cancelabsent") }}
                  </span>
                  <span
                    v-if="
                      isType(item, 'autocomment') &&
                      item.comment == 'activecanceled'
                    "
                  >
                    {{ $t("lang.task.activecanceled") }}
                  </span>
                  <span
                    v-if="
                      isType(item, 'autocomment') &&
                      item.comment == 'activeabsentyou'
                    "
                  >
                    {{ item.name }} {{ $t("lang.task.activeabsentyou") }}
                  </span>
                  <span
                    v-if="
                      isType(item, 'autocomment') &&
                      item.comment == 'activecanceledyou'
                    "
                  >
                    {{ item.name }} {{ $t("lang.task.activecanceledyou") }}
                  </span>

                  <pre
                    v-if="
                      isType(item, 'comment') && !isType(item, 'autocomment')
                    "
                    class="text-muted"
                    v-html="formatTokensAgency(getEmail(item.comment, item.id))"
                  ></pre>
                </div>
              </div>
            </div>
          </div>
        </li>
        </template>
      </ul>
      <div v-if="showLoadMore" class="text-center mt-4 mb-2 px-2">
        <button
          type="button"
          class="btn btn-outline-primary btn-sm"
          :disabled="loadingMore"
          @click="$emit('load-more-activities')"
        >
          <span v-if="loadingMore">{{ $t("lang.opportunities.left_panel_loading") }}</span>
          <span v-else>{{ $t("lang.button.load_more") }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { emailsService } from "@/_services";
import { mapState, mapActions } from "vuex";
import CalendlyEvent from "@/components/Common/CalendlyEvent.vue";
import OpportunityOutputCard from "@/components/Opportunities/OpportunityOutputCard.vue";
import TimelineEmailCard from "@/components/Opportunities/TimelineEmailCard.vue";
import TimelineCalendarActivityCard from "@/components/Opportunities/SingleOpportunity/TimelineCalendarActivityCard.vue";
import { formattersMixin, campaignUtilsMixin } from "@/_mixins/";

export default {
  data() {
    return {
      loading: true,
      tooltip: [],
      response_message: this.$t("lang.general.readerroremail"),
      bodies: [],
      isModalVisible: false,
      openitem: {},
      lastEventDate: false,
      tags: {},
      showtags: false,
      body: '',
      worddetected: [],
    };
  },
  props: {
    campaignTokens: Object,
    timelineComming: Array,
    timelinePassed: Array,
    timelineRecent: Array,
    emails: Object,
    status: Object,
    business: Object,
    user_id: null,
    activateSpark: String,
    temperatureBgColors: Array,
    showLoadMore: {
      type: Boolean,
      default: false,
    },
    loadingMore: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    CalendlyEvent,
    OpportunityOutputCard,
    TimelineEmailCard,
    TimelineCalendarActivityCard,
  },

  mixins: [formattersMixin, campaignUtilsMixin],

  computed: {
    isCommingTimelineEmpty() {
      return this.timelineComming.length == 0;
    },

    isPassedTimelineEmpty() {
      return this.timelinePassed.length == 0;
    },
    ...mapState({
      currentUser: (state) => state.authentication.user,
      availableTokens: (state) => state.optionsList.all["available_tokens"],
      completeLoadingOpp: (state) => state.optionsList.completeLoadingOpp
    }),
  },
  created() {
    if(this.currentUser.role_id != 2){
      this.getAllOppParams();
    }
    this.timelinePassed.forEach((item) => {
      if (item.type == "emailreceived" && item.comment == "readerroremail") {
        item.comment = "loading...";
        emailsService.getById(item.id).then((r) => {
          item.comment = r.response_message;
        });
      }
    });
    this.initDefaultEmailExpansion();
  },

  methods: {
    ...mapActions("optionsList", {
      getAllOppParams: "getAllOppParams",
    }),
    isUserBdr() {
      return (this.currentUser.team_role_id == 2 && this.currentUser.role_id == 2)
    },
    shouldShowPassedTimelineItem(item) {
      if (item.link === "createdopportunity") {
        return true;
      }
      if (this.isRebootTaskCardItem(item)) {
        return true;
      }
      if (this.isType(item, "activity")) {
        return true;
      }
      return (
        !this.isType(item, "activity") &&
        !this.isType(item, "task") &&
        (this.currentUser.role_id != 4 || item.event_id != 2)
      );
    },
    hasPermissions(perm) {
      return this.$store.getters["authentication/hasPermissions"](perm);
    },
    setLastEventDate(value) {
      if (!this.lastEventDate) {
        this.lastEventDate = value;
      }
    },
    highlightedText(w) {
      const regex = new RegExp(w, 'gi');
      return this.body.replace(regex, '<strong class="text-success">$&</strong>');
    },
    retag(item) {

      let data = {
          'id': item.response_id,
          'link_id': item.link_id,
          'business_contact_id': item.business_contact_id,
          'email_response_id': item.id,
          'email_status_id': false
        }

      emailsService
        .reTagEmail(data)
        .then((r) => {
          this.$set(this.tags, item.id, r);
          this.body = r['analyzed']['body'];
          this.worddetected = r['analyzed']['worddetected'];
          this.showtags = true;
        });
    },
    removeSpace(chain) {
      chain = chain.replace(/\n\s*\n\s*\n/g, "\n");
      return chain.trim();
    },
    openItem(id) {
      this.$set(this.openitem, id, this.openitem[id] != true);
    },
    permissionFront(item) {
      if (
        this.status.id == 8 &&
        !["34", "35"].includes(this.status.link_status_reason_id) &&
        this.lastEventDate
      ) {
        if (this.lastEventDate < item.creation_date) {
          return true;
        }
      }
      return (
        this.currentUser.team_role_id == undefined ||
        this.currentUser.team_role_id != 3
      );
    },
    isOpenItem(item) {
      return this.openitem[item.id] == true;
    },
    isTimelineEmailItem(item) {
      // determina si el item del timeline es un email para mostrarlo con su card especifica
      return (
        item.type == "emailreceived" ||
        item.type == "emailsent" ||
        item.type == "emailssent" ||
        item.type == "emailsentopportunity"
      );
    },
    initDefaultEmailExpansion() {
      // determina que email es el mas cercano en fecha para por defecto ponerlo en abierto su accordion
      const emailItems = this.timelinePassed.filter((item) =>
        this.isTimelineEmailItem(item)
      );
      if (!emailItems.length) {
        return;
      }
      let latestItem = emailItems[0];
      let latestTime = this.parseTimelineItemDate(latestItem.creation_date);
      emailItems.forEach((item) => {
        const itemTime = this.parseTimelineItemDate(item.creation_date);
        if (itemTime > latestTime) {
          latestItem = item;
          latestTime = itemTime;
        }
      });
      this.$set(this.openitem, latestItem.id, true);
    },
    parseTimelineItemDate(stringDate) {
      if (!stringDate) {
        return 0;
      }
      const dateArray = stringDate.split(/-|\s|:/);
      const date = new Date(
        dateArray[0],
        dateArray[1] - 1,
        dateArray[2],
        dateArray[3] || 0,
        dateArray[4] || 0,
        dateArray[5] || 0
      );
      return isNaN(date.getTime()) ? 0 : date.getTime();
    },
    showModal() {
      this.isModalVisible = true;
    },
    closeModal(item) {
      item.answer = 0;
      this.isModalVisible = false;
    },

    blocked() {
      return false;
      // siempre habilitar la respuesta de emails
      return (
        this.status.name != "Positive" &&
        this.status.name != "Created" &&
        this.status.name != "Working"
      );
    },
    isMeetingItem(item) {
      return item && (item.event_id == 3 || item.event_id === "3");
    },
    isMeetingPast(item) {
      if (!this.isMeetingItem(item) || !item.event_date) return false;
      const raw = String(item.event_date).trim();
      const normalized = raw.includes("T") ? raw : raw.replace(" ", "T");
      const date = new Date(normalized);
      if (isNaN(date.getTime())) return false;
      return date.getTime() < Date.now();
    },
    timelineIconClasses(item, role_id) {
      const icon = this.timelineIcon(item, role_id);
      if (Array.isArray(icon)) {
        return icon;
      }
      if (this.isMeetingItem(item) && icon === "icon-calendar") {
        return [
          icon,
          "timeline-meeting-icon",
          this.isMeetingPast(item)
            ? "timeline-meeting-icon--past"
            : "timeline-meeting-icon--future",
        ];
      }
      return icon;
    },
    timelineIcon(item, role_id) {
      if (item.type == "emailreceived") {
        return [
          "icon-mail",
          "timeline-email-icon",
          "timeline-email-icon--received",
        ];
      }
      const sentKind = this.sentEmailKind(item);
      if (sentKind === "manual") {
        return [
          "icon-paper-plane-o",
          "timeline-email-icon",
          "timeline-email-icon--sent",
        ];
      }
      if (sentKind === "reminder" || sentKind === "reschedule") {
        return [
          "icon-bell-o",
          "timeline-email-icon",
          "timeline-email-icon--reminder",
        ];
      }
      if (sentKind === "auto" || item.type == "emailssent") {
        return [
          "icon-bolt",
          "timeline-email-icon",
          "timeline-email-icon--sequence",
        ];
      }

      if (this.isEmail(item)) {
        return "icon-mail";
      }

      if (item.type == "activity") {
        if (role_id == 4) return "";
        return ["icon-calendar", "timeline-activity-icon"];
      }

      if (item.link) {
        if (this.isRebootTaskCardItem(item)) {
          const theme = this.getTaskCardTheme(item.event_id);
          return [
            "icon-phone-call",
            "timeline-task-icon",
            `timeline-task-icon--${theme.variant}`,
          ];
        }
        if(item.event_id == 1 && role_id == 4) return "icon-one-finger-tap";
        else if (role_id == 4) return "";
        return "icon-one-finger-tap";
      } else {
        if (this.isType(item, "event")) {
          if (item.event_id === "1") {
            return "icon-phone-call";
          } else {
            if (item.event_id == 3) {
              return "icon-calendar";
            }
            if(role_id == 4) return "";
            return "icon-clock";
          }
        }
        if (this.isType(item, "comment")) {
          return "icon-comment";
        }
        if (this.isType(item, "task")) {
          return "icon-task";
        }
      }
    },
    getEmail(body,id) {
      
      if(body){
        body = body.replace("<a", '<a target="_blank" ');
        if(!body.includes("<p>")){
          body = body.replace(/\n/g, "<br>");
        }
      }
      return body
    },
    getProspectData(item){
      return item.business_contact_id
    },
    switchTextarea(item) {
      item.answer = "1";
      this.showModal();
    },
    isType(item, type) {
      if (type == "autocomment" && item.comment == "absentactive") {
        return true;
      }
      if (type == "autocomment" && item.comment == "activecanceled") {
        return true;
      }
      if (type == "autocomment" && item.comment == "activeabsentyou") {
        return true;
      }
      if (type == "autocomment" && item.comment == "activecanceledyou") {
        return true;
      }
      if (type == "autocomment" && item.comment == "cancelrefused") {
        return true;
      }
      if (type == "autocomment" && item.comment == "cancelabsent") {
        return true;
      }
      return item.type == type;
    },
    isEmail(item) {
      return (
        item.type == "emailreceived" ||
        item.type == "emailssent" ||
        item.type == "emailscheduled" ||
        item.type == "emailsentopportunity"
      );
    },

    isEmailreceived(item) {
      return item.type == "emailreceived";
    },
    checkName(name) {
      if (name.includes("Generic")) {
        return "Responsble";
      } else {
        return name;
      }
    },
    calcSpanDate(stringDate) {
      // Creo un Date con la fecha enviada como parametro
      var dateArray = stringDate.split(/-|\s|:/);
      var date = new Date(
        dateArray[0],
        dateArray[1] - 1,
        dateArray[2],
        dateArray[3],
        dateArray[4],
        dateArray[5]
      );

      // Creo un Date de ayer, hoy y mañana
      var yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      var today = new Date();
      var tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);

      // Verifico el dia para ver si es ayer, hoy o mañana, caso contrario devuelvo la fecha
      var processdate;

      if (date.setHours(0, 0, 0, 0) === today.setHours(0, 0, 0, 0)) {
        var processdate = "Today ";
      } else if (date.setHours(0, 0, 0, 0) === tomorrow.setHours(0, 0, 0, 0)) {
        var processdate = "Tomorrow ";
      } else if (date.setHours(0, 0, 0, 0) === yesterday.setHours(0, 0, 0, 0)) {
        var processdate = "Yesterday ";
      } else {
        var processdate = `${dateArray[2]}-${dateArray[1]}-${dateArray[0]}`;
      }

      if (dateArray[3] !== undefined) {
        processdate =
          processdate + " " + `${dateArray[3]}:${dateArray[4]}:${dateArray[5]}`;
      }

      return processdate;
    },
    unlikFromOportunity(item) {
      // Mostrar SweetAlert2 para confirmar la acción
      this.$swal({
        type: 'warning',
        title: this.$t('lang.label.areyousure'),
        text: this.$t('lang.label.youwontbeabletorevertthis'),
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33a2c',
        confirmButtonText: 'Sí',
      }).then((result) => {
        if (result.value) {
          // Función ejecutada cuando se confirma en el modal
          emailsService
            .disassociateOpportunityEmail(
              item.id
            )
            .then(() => {
              // Recarga la página después de ejecutar la función
              window.location.reload();
            });
        }
      });
    },

    isRebootTaskCardItem(item) {
      return (
        this.isType(item, "task") &&
        (this.hasPermissions("superAdmin") ||
          this.isUserBdr() ||
          this.currentUser.role_id == 3 ||
          (this.currentUser.role_id == 4 && item.event_id == 1))
      );
    },
    getTaskCardTheme(eventId) {
      const id = Number(eventId);
      const timelineColor = this.getTaskTemperatureColors(eventId, "bg");
      if (id === 1) {
        return {
          variant: "success",
          avatarBg: "#E6F4EA",
          avatarColor: "#1E8E3E",
          badgeBg: "#E6F4EA",
          badgeColor: "#1E8E3E",
          badgeLabelKey: "lang.opportunities.output_badge_meeting_booked",
          timelineColor,
        };
      }
      if ([2, 3, 4, 6].includes(id)) {
        return {
          variant: "warning",
          avatarBg: "#FFF7E6",
          avatarColor: "#B45309",
          badgeBg: "#FFF7E6",
          badgeColor: "#B45309",
          badgeLabelKey: "lang.opportunities.output_badge_callback",
          timelineColor,
        };
      }
      return {
        variant: "danger",
        avatarBg: "#FCE8E6",
        avatarColor: "#D93025",
        badgeBg: "#FCE8E6",
        badgeColor: "#D93025",
        badgeLabelKey: "lang.opportunities.output_badge_no_interest",
        timelineColor,
      };
    },
    // Task Management Methods
    getTaskTemperatureColors(taskOutputId, type) {
      if (type == "text" && taskOutputId == 1) {
        return "#FFFFFF";
      } else if (type == "text") {
        return "#000000";
      }

      const taskColors = [
        { id: 1, color: "#28a745" },
        { id: 2, color: "#ffc107" },
        { id: 3, color: "#ffc107" },
        { id: 4, color: "#ffc107" },
        { id: 5, color: "#dc3545" },
        { id: 6, color: "#ffc107" },
        { id: 7, color: "#dc3545" },
        { id: 8, color: "#dc3545" },
        { id: 9, color: "#dc3545" },
      ];

      const found = taskColors.find((el) => el.id == taskOutputId);
      const bg = found ? found.color : "#dc3545";

      return type === "bg" ? bg : "#FFFFFF";
    },

    getTaskTypeLabel(temperatureId) {
      if (!this.temperatureBgColors) return '';
      
      const itemFound = this.temperatureBgColors.find(
        e => e.id == temperatureId
      );

      return itemFound ? itemFound.label : 'Unknown';
    },

    getTaskOutputLabel(eventId) {
      // Mapear event_id a labels de salida de tarea
      const outputLabels = {
        1: this.$t("lang.label.output_meeting_booked"),
        2: this.$t("lang.label.output_call_back"),
        3: this.$t("lang.label.output_no_answer"),
        4: this.$t("lang.label.output_no_phone"),
        5: this.$t("lang.label.output_no_interest"),
        6: this.$t("lang.label.output_neutral"),
        7: this.$t("lang.label.output_out_of_scope"),
        8: this.$t("lang.label.output_out_of_scope_company"),
        9: this.$t("lang.label.output_wrong_number"),
      };

      return outputLabels[eventId] || this.$t("lang.task.output.unknown");
    },
  },
};
</script>
<style>
pre a {
  color: #5054EB !important;
}

pre {
  overflow-x: auto;
  white-space: pre-wrap;
  white-space: -moz-pre-wrap;
  white-space: -pre-wrap;
  white-space: -o-pre-wrap;
  word-wrap: break-word;
  font-family: inherit !important;
}

blockquote {
  max-width: 600px !important;
}
.wTimeLine ul li.activityLine:first-child .card {
  background: #eaeaea;
  border-color: #eaeaea;
}

.timeline-meeting-slot {
  background: transparent;
  padding: 0;
  border: none;
}

/* Room for circular icons centered on the border (parent has overflow-auto) */
.wTimeLine {
  padding-left: 0.875rem;
}

.wTimeLine .activityLine {
  position: relative;
  overflow: visible;
}

.wTimeLine .activityLine > .iconline.timeline-meeting-icon,
.wTimeLine .activityLine > .iconline.timeline-task-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
  min-width: 1.5rem;
  min-height: 1.5rem;
  font-size: 0.7rem;
  line-height: 1;
  border-radius: 50%;
  box-sizing: border-box;
  position: absolute;
  left: 0;
  top: 0.35rem;
  transform: translateX(-50%);
  margin-left: 0;
  padding: 0;
  z-index: 1;
}

.wTimeLine .activityLine > .iconline.timeline-meeting-icon--future {
  background: #ecfdf5;
  border: 2px solid #10b981;
  color: #111827;
}

.wTimeLine .activityLine > .iconline.timeline-meeting-icon--past {
  background: #4b5563;
  border: 2px solid #4b5563;
  color: #fff;
}
.wTimeLine ul li.activityLine:first-child .card .text-muted {
  line-height: 1.2;
  margin-top: 20px;
}
.iconline {
  margin-left: -29px;
}
.opportunity .wTimeLine .text-muted.breaknormal {
  white-space: pre-line;
  word-wrap: break-Word;
  line-height: 1.2;
}

.icon-task {
  color: #ffc107;
}

.icon-task:before {
  content: "✓";
  font-weight: bold;
}

.task-card {
  border: none !important;
  border-radius: 8px !important;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  margin-bottom: 8px;
}

.task-card--reboot {
  background: #fff !important;
  border: 1px solid #e5e7eb !important;
  box-shadow: none;
  color: #111827;
}

.wTimeLine .activityLine > .iconline.timeline-task-icon {
  color: #fff !important;
}

.wTimeLine .activityLine > .iconline.timeline-task-icon--success {
  background: #1e8e3e;
  border: 2px solid #1e8e3e;
}

.wTimeLine .activityLine > .iconline.timeline-task-icon--warning {
  background: #b45309;
  border: 2px solid #b45309;
}

.wTimeLine .activityLine > .iconline.timeline-task-icon--danger {
  background: #d93025;
  border: 2px solid #d93025;
}

.wTimeLine .activityLine > .iconline.timeline-email-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
  min-width: 1.5rem;
  min-height: 1.5rem;
  font-size: 0.7rem;
  line-height: 1;
  border-radius: 50%;
  box-sizing: border-box;
  position: absolute;
  left: 0;
  top: 0.35rem;
  transform: translateX(-50%);
  margin-left: 0;
  padding: 0;
  z-index: 1;
  background: #fff;
}

.wTimeLine .activityLine > .iconline.timeline-email-icon--received {
  border: 2px solid #4b4be1;
  color: #3c3489;
  background: #eeeefc;
}

.wTimeLine .activityLine > .iconline.timeline-email-icon--sent {
  border: 2px solid #10b981;
  color: #065f46;
  background: #d1fae5;
}

.wTimeLine .activityLine > .iconline.timeline-email-icon--reminder {
  border: 2px solid #f59e0b;
  color: #92400e;
  background: #fef3c7;
}

.wTimeLine .activityLine > .iconline.timeline-email-icon--sequence {
  border: 2px solid #6366f1;
  color: #3730a3;
  background: #eef2ff;
}

.wTimeLine .activityLine > .iconline.timeline-activity-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
  min-width: 1.5rem;
  min-height: 1.5rem;
  font-size: 0.7rem;
  line-height: 1;
  border-radius: 50%;
  box-sizing: border-box;
  position: absolute;
  left: 0;
  top: 0.35rem;
  transform: translateX(-50%);
  margin-left: 0;
  padding: 0;
  z-index: 1;
  background: #ccfbf1;
  border: 2px solid #fff;
  box-shadow: 0 0 0 1px #ccfbf1;
  color: #115e59;
}
</style>